import { FEATURES, SEARCH_GROUPS } from '@constants/Text'
import { lazyLoadView } from '@utils/LazyLoad'

export default [
  {
    path: '/boletador',
    name: 'boletador',
    redirect: '/boletador/geral',
    meta: {
      can_show: FEATURES.BOLETADOR,
      search: {
        title: 'Boletador',
        description: 'Boletagem de ordens e operações de investimento',
        keywords: ['boletador', 'boletagem', 'ordens', 'operações', 'boletas'],
        icon: 'mdi-ticket-percent',
        group: SEARCH_GROUPS.FERRAMENTAS,
      },
    },
    component: () =>
      lazyLoadView(
        import('@src/modules/boletador/views/nav-bar/view-nav-bar.vue')
      ),
    children: [
      {
        path: 'geral',
        name: 'boletador.overview',
        meta: {
          can_show: FEATURES.BOLETADOR,
        },
        component: () =>
          lazyLoadView(
            import('@modules/boletador/views/boletador/view-boletador.vue')
          ),
      },
    ],
  },
]
